import { Component, Inject, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Base } from '../../base';
import { MatDialog } from '@angular/material/dialog';
import { ValidationService } from '../../../../utils/util.validation';

@Component({
  selector: 'app-dialog-poblacion-generar',
  templateUrl: './dialog-poblacion-generar.component.html',
  styleUrls: ['./dialog-poblacion-generar.component.css']
})
export class DialogPoblacionGenerarComponent extends Base {

  @ViewChild('email1Input') email1Input!: ElementRef;
  @ViewChild('email2Input') email2Input!: ElementRef;
  @Output() generateEvent = new EventEmitter<number>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogPoblacionGenerarComponent>,
    private matDialog: MatDialog,
    private utilsApp: ValidationService,
    private fb: FormBuilder
  ) {
    super();
    this.frmOptions = this.fb.group({
      billValue: [null,Validators.required],
      selectedOption: [],
      emailOwner: [{ value: "correo@prueba.com", disabled: this.isLocked }, [Validators.required, this.utilsApp.emailValidation()]],
      emailAsesor: [{ value: "correo@prueba.com", disabled: this.isLocked }, [Validators.required, this.utilsApp.emailValidation()]],
    });
  }

  frmOptions: FormGroup;
  optionSelected: any = 0;
  isLocked: boolean = true;
  billsData: any[] = [];

  onSelectionChange(event: any) {
    const selectedOption = this.frmOptions.value.selectedOption;
    if (selectedOption === '1') {
      this.email1Input.nativeElement.focus();
    } else if (selectedOption === '2') {
      this.email2Input.nativeElement.focus();
    }    
  }

  modifyData() {
    this.isLocked = !this.isLocked;
    if (this.isLocked) {
      this.frmOptions.get('emailOwner')?.disable();
      this.frmOptions.get('emailAsesor')?.disable();
      this.frmOptions.get('emailOwner')?.setValue("correo@prueba.com");
      this.frmOptions.get('emailAsesor')?.setValue("correo@prueba.com");
    } else {
      this.frmOptions.get('emailOwner')?.enable();
      this.frmOptions.get('emailAsesor')?.enable();
      // Focusing the input based on selected option
      if (this.frmOptions.value.selectedOption === '1') {
        this.email1Input.nativeElement.focus();
      } else if (this.frmOptions.value.selectedOption === '2') {
        this.email2Input.nativeElement.focus();
      }
    }
  }

  sendBill() {
    if (!this.frmOptions.valid) {
      this.showMessageDialog("Error", "Debe seleccionar una opción antes de enviar.", "Aceptar", "", true, 1, this.matDialog, (_: any) => { });
      return;
    }
    switch (this.frmOptions.value.selectedOption) {
      case '1': // whatsapp
        // Emit event to the parent component
        this.generateEvent.emit(this.frmOptions.value.selectedOption);
        const telefono = this.frmOptions.get('cellphone')?.value;
        const url = 'https://wa.me/+57' + telefono; // abrir whatsapp
        window.open(url, '_blank', 'noopener,noreferrer');
        this.close();
        break;
      case '2': //email
        this.showMessageDialog("Exito", "Se envio correctamente", "Aceptar", "", true, 1, this.matDialog, (_: any) => { });
        this.close();
        break;
      default:
        this.showMessageDialog("Error", "Debe seleccionar una opción válida.", "Aceptar", "", true, 1, this.matDialog, (_: any) => { });
    }
  }

  downloadBill(){

  }

  validatePhone(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  close() {
    this.dialogRef.close();
  }

  get getControl(): { [key: string]: AbstractControl } {
    return this.frmOptions.controls;
  }
}
